import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.127 0C7.683 0 4.881 2.786 4.881 6.211c0 2.2 1.178 4.226 3.05 5.338l-.608 4.893H2.23c-1.06 0-1.924.86-1.924 1.918v4.01c0 1.059.863 1.92 1.924 1.92h17.54c1.06 0 1.924-.861 1.924-1.92v-4.01a1.924 1.924 0 0 0-1.925-1.918h-4.851l-.607-4.886a6.22 6.22 0 0 0 3.061-5.345C17.372 2.786 14.571 0 11.127 0Zm9.805 25.862H1.068a1.067 1.067 0 0 0-.755 1.825c.2.2.472.313.755.313h19.864a1.067 1.067 0 0 0 .755-1.825c-.2-.2-.472-.313-.755-.313Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}